import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarDayFn = /* @__PURE__ */ createRecipe('calendar-day', {}, [])

const calendarDayVariantMap = {}

const calendarDayVariantKeys = Object.keys(calendarDayVariantMap)

export const calendarDay = /* @__PURE__ */ Object.assign(memo(calendarDayFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarDay',
  __getCompoundVariantCss__: calendarDayFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarDayVariantKeys,
  variantMap: calendarDayVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarDayVariantKeys)
  },
  getVariantProps: calendarDayFn.getVariantProps,
})